import { DEFAULT_TINYMCE_OPTIONS } from '../../../../shared/default-tinymce-options';

export const FDD_DEFAULT_TINYMCE_OPTIONS = {
    ...DEFAULT_TINYMCE_OPTIONS,

    selector: '#tinyMceDefinitionDetails',
    content_css: '/assets/css/fdd-default-tinymce.css',

    plugins: [
        'fullscreen',
        'code',
        'link',
        'image'
    ],

    toolbar1: 'blocks fontsizeinput | searchreplace | charmap subscript superscript | link | image | code fullscreen',
    toolbar2: 'alignleft aligncenter | bold italic underline | forecolor backcolor | bullist numlist | removeformat | undo redo | visualchars visualblocks | vEDocs',
    //toolbar1: 'fontsizeinput | searchreplace | code fullscreen',
    //toolbar1: 'blocks fontsizeinput | outdent indent | searchreplace | charmap subscript superscript | removeformat',
    //toolbar2: 'bold italic underline strikethrough | forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist | table | undo redo | visualchars visualblocks | code fullscreen',
    //toolbar3: 'pdfPreview | vPessoas vLocais vDatas vForm',
};
